//#region IMPORTS
import React from 'react';
import { Row, Col, Container, Alert } from 'react-bootstrap';
import language from '../../config/es';
//#endregion IMPORTS

export const columns = [
  {
    name: language.messages.gridConciliationDaily.operationNumber,
    sortable: true,
    selector: "operationNumber",
    wrap: true,
    cell: (row) => (
      <span>
        <div className="text-capitalize">{row.operationNumber}</div>
        <div className="text-capitalize small-font">{language.messages.gridConciliationDaily.trace}: <strong>{row.trace}</strong></div>
      </span>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.clientDni,
    sortable: true,
    selector: "clientDni",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{row.clientDni}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.amount,
    sortable: true,
    selector: "amount",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{Number.parseFloat(row.amount).toFixed(2)}</div>
    ),
  },
  {
    name: language.messages.gridConciliationDaily.billAmount,
    sortable: true,
    selector: "billAmount",
    wrap: true,
    cell: (row) => (
      <div className="text-capitalize">{Number.parseFloat(row.billAmount).toFixed(2)}</div>
    ),
  }
];

export const ExpandableComponent = ({ data }) => 
<Container>
<Row className="justify-content-md-center">
  <Col>
    {
      data.obs !== 'null'?
      <Alert variant="danger">{data.obs}</Alert>:
      <Alert variant="primary" text='dark'>No se encontró ningún problema</Alert>
    }
  </Col>
</Row>
</Container>;
